module.exports = __webpack_public_path__ + "assets/img/teacher (13).c5b4c788.png";